export default __webpack_public_path__ + "static/media/google.d74131b9.png";